import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { SelectionToggle } from '../../../custom_shared/components';
import { useAppStore } from '../../stores';
import WorksheetsFilter from './WorksheetsFilter';
import './WorksheetsPanelHeader.less';

const WorksheetsPanelHeader: React.FC = () => {
    const { worksheetsSubmissionStore } = useAppStore();

    return (
        <div className="worksheets-panel-header-container">
            <span className="worksheets-panel-title">Worksheets</span>
            <div className="worksheets-panel-actions">
                <WorksheetsFilter />
                <SelectionToggle
                    enabled={worksheetsSubmissionStore.selectiveModeEnabled}
                    onChange={worksheetsSubmissionStore.setSelectiveModeEnabled}
                />
            </div>
        </div>
    );
};

export default observer(WorksheetsPanelHeader);
